var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.375 3.25a4.388 4.388 0 0 1 4.376 4.375v8.75a4.388 4.388 0 0 1-4.376 4.375h-8.75a4.389 4.389 0 0 1-4.375-4.375v-8.75A4.388 4.388 0 0 1 7.626 3.25zm0-1.75h-8.75C4.258 1.5 1.5 4.256 1.5 7.625v8.75c0 3.369 2.757 6.125 6.126 6.125h8.75c3.368 0 6.124-2.756 6.124-6.125v-8.75c0-3.369-2.756-6.125-6.125-6.125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.691 7.633a1.317 1.317 0 1 1 0-2.634 1.317 1.317 0 0 1 0 2.634M12 8.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0-1.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5"
  })));
};
export default SvgInstagram;